const wizard = {
    prefixTemplate: ({ id, simulationId }) => `/rip/${id}/simulations/${simulationId}`,
    items: [
        {
            name: 'Client',
            target: 'overview',
        },
        {
            name: 'Produits',
            target: 'products',
        },
        {
            name: 'Simulation',
            target: 'simulation',
        },
    ],
};

export default wizard;
